import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Link from "../../link";
import { ConditionResource } from "./condition-resource";

/**
 * Type to allow only certain resource type values.
 */
export type RuleResourceType = "Regular" | "BuiltIn";

/**
 * Rule representation for {@link PolicyResource}
 */
@JsonObject()
export class RuleResource {
    /**
     * Non null collection of entity definition resource links to which this policy applies.
     */
    @JsonProperty("definitions")
    @JsonElementType(Link)
    definitions: Array<Link> = [];

    /**
     * Unique identifier of the rule, usually GUID string.
     * This identifier is automatically generated by the system and shall not be set freely by user.
     */
    @JsonProperty("identifier")
    readonly identifier: string;

    /**
     * Non null collection of conditions which needs to be fulfilled uniformly in order to trigger this rule
     * (i.e. conditions are combined with "AND" logical operator).
     */
    @JsonProperty("conditions")
    @JsonElementType(ConditionResource)
    conditions: Array<ConditionResource> = [];

    /**
     * Non null collection of permissions this rule grands,
     *
     * @remarks
     * The permissions are simple string constants recognized by the system.
     */
    @JsonProperty("permissions")
    @JsonElementType(String)
    permissions: Array<string> = [];

    /**
     * If set to true, this rule only applies to entities created by the logged on user.
     */
    @JsonProperty("createdByLoggedOnUser")
    createdByLoggedOnUser: boolean;

    /**
     * The type of the rule. It is not applicable when creating resource.
     * Indicates if this object is owned by the system and cannot be updated by users.
     *
     * @remarks
     * Possible values are: "Regular" or "BuiltIn".
     */
    @JsonProperty("type")
    type: RuleResourceType;

    /**
     * Indicates if this object is owned by the system and cannot be updated by users.
     */
    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    constructor(init?: Partial<RuleResource>) {
        Object.assign(this, init);
    }
}
